export class NeoCiiuExcluido{
    constructor(
        public idCliente:Number,
        public ciius:Number[]=[],
        public idUsuario:Number
    ){}
}